exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-ed0f2c92]{position:fixed;width:100%;background:#fff;left:0}.container[data-v-ed0f2c92]{display:flex;justify-content:space-between;align-items:center}@media screen and (max-width:816px){.container[data-v-ed0f2c92]{padding:8px 16px}}@media screen and (max-width:470px){.for-pn[data-v-ed0f2c92]{padding:8px 16px 25px}}img[data-v-ed0f2c92]{cursor:pointer;max-height:56px}h3[data-v-ed0f2c92]{font-weight:700;font-size:24px;line-height:32px;text-align:center;color:#454545;position:absolute;left:50%;transform:translate(-50%);cursor:pointer}@media screen and (max-width:816px){h3[data-v-ed0f2c92]{font-size:16px;line-height:25px}}@media screen and (max-width:470px){.for-pn-title[data-v-ed0f2c92]{top:60px}}.logo[data-v-ed0f2c92]{max-height:40px;margin:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed0f2c92","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 90
// module chunks = 0